export enum ColorSchemePreferenceEnum {
  Light = 'Light',
  Dark = 'Dark',
  System = 'System',
}
